// import RecommendedActions from './recommended-actions.js'
import showGrid from './grid/show-grid.js'

export default class CostReport {
  constructor (params = {}) {
    console.log('CostReport constructor')

    this.htmlTemplate = `
      <wp-card class="as-full-height">
        <header>
          <h2>Cost Report</h2>
          <div data-action="full-screen">Full screen</div>
        </header>
        <section class="fill-space">
          <wp-container class="as-fill-space width-full">
            <div id="for-actions">Recommended actions [SOON]</div>
            <wp-container id="grid-container" class="as-fill-space width-full">Pending data...</wp-container>
          </wp-container>
        </section>
      </wp-card>
    `

    this.mountedOn = null

    this.gridApi = null

    this.numberPowTen = params.numberPowTen
  }

  mount (element) {
    console.log('CostReport mount')
    element.innerHTML = this.htmlTemplate
    this.mountedOn = element

    this.render({ numberPowTen: this.numberPowTen })
  }

  /**
   *
   * @param {Object} params
   * @param {Object} params.data
   * @param {String} params.accountingOrganisationId
   * @returns
   */
  render (params = {}) {
    console.log('CostReport render')
    if (!this.mountedOn) return

    this.accountingOrganisationId = params.accountingOrganisationId
    this.data = params.data
    // renderGrid(this)

    window.document.addEventListener('pp:onBudgetFileRead', (event) => {
      console.log('window.document pp:onBudgetFileRead', event)
      const cellsTable = event.detail.cellsTable
      const groupHeadersMap = event.detail.groupHeadersMap

      showGrid({
        cellsTable,
        gridContainerId: 'grid-container',
        numberPowTen: params.numberPowTen,
        groupHeadersMap
      })
    })

    // this.recommendedActions = new RecommendedActions({ // SOON
    //   budgetModule: this,
    //   containerId: 'for-actions'
    // })
  }
}
